<template>
    <div class="nav flex">
        <div class="nav-logo"></div>
        <div class="nav-menu flex">
            <!-- <router-link class="nav-tab cursor" to="/dashboard">首页</router-link> -->
            <router-link class="nav-tab cursor" to="/order">期刊订阅</router-link>
            <router-link class="nav-tab cursor" to="/batchorder">批量订阅</router-link>
            <router-link class="nav-tab cursor" to="/address">地址管理</router-link>
           <!--  <router-link class="nav-tab cursor" to="/orderpartsend">分寄订阅</router-link>-->
            <router-link class="nav-tab cursor" to="/ordercheck">我的订单</router-link>
            <!-- <router-link class="nav-tab cursor" to="/dashboard">我的发票</router-link> -->
            <router-link v-if="userInfo.userType == 2" class="nav-tab cursor" to="/message/index">通讯员</router-link>
            <!-- <router-link class="nav-tab cursor" to="/logiccheck">物流查询</router-link> -->
        </div>
        <el-dropdown class="avatar-container " trigger="click">
            <div class="avatar-wrapper flex vc">
              <img src="../../assets/img/man.png" class="user-avatar">
              <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <router-link to="/profile/index">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>
              <el-dropdown-item  @click.native="logout">
                <span style="display:block;">退出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
    </div>
</template>
<script>
import {getUserInfo} from '@/util/auth.js'
export default {
  data () {
    return {
      tabs: [
        {
          text: '期刊订阅',
          active: true
        },
        {
          text: '订单查询',
          active: false
        },
        {
          text: '物流查询',
          active: false
        }
      ]
    }
  },
  created () {
    this.userInfo = getUserInfo()
  },
  methods: {
    logout () {
      this.$store.dispatch('user/logout', {})
    }
  }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';
    .nav-tab {
        color: rgba(51, 51, 51, 0.397);
        padding: 0 30px;
    }
    .nav-tab.link-active {
        color:#333;
        font-weight: bold;
        position: relative;
    }
    .nav-tab.link-active:after {
        content:'';
        position: absolute;
        bottom: 15px;
        left: 30px;
        width: 16px;
        height: 4px;
        border-radius: 2px;
        background: $linearColor;
    }
    .nav {
        box-shadow:0px 0px 30px 0px rgba(73,73,73,0.09);
        height: 70px;
        line-height: 70px;
        justify-content: space-between;
    }
    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        height: 70px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 6px;

        }

        .el-icon-caret-bottom {
          cursor: pointer;
          font-size: 12px;
        }
    }
  }
</style>
